import { render, staticRenderFns } from "./AboutYourPurchase.vue?vue&type=template&id=154dc934&scoped=true&"
import script from "./AboutYourPurchase.vue?vue&type=script&lang=js&"
export * from "./AboutYourPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154dc934",
  null
  
)

export default component.exports